import React from 'react';



type Props = {
	children: React.ReactNode,
};



const SimpleNavigationButton: React.FC<Props> = (props) => {
	const {
		children,
	} = props;

	return (
		<div className="simple-nav-button">
			{children}
		</div>
	);
};



export default SimpleNavigationButton;
